(() => {
  'use strict';

  const HEADER = 'header-component';
  const MOBILE_QUERY = '(max-width: 768px)';
  const OVERFLOW_TOLERANCE = 1;

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  const navContentOverflows = (header) => {
    const nav = header.navContainer;
    const grid = header.headerGrid;

    if (!nav || !grid) return false;

    const wasHidden = nav.hasAttribute('hidden');
    const hadFitNav = grid.hasAttribute('fit-nav');
    const placedBurger = grid.querySelector(':scope > .drawer-menu-toggle');

    if (wasHidden) nav.removeAttribute('hidden');
    if (hadFitNav) grid.removeAttribute('fit-nav');
    if (placedBurger) placedBurger.remove();

    const icons = grid.querySelector('.header__icons-right');
    const iconStyle = icons ? getComputedStyle(icons) : null;
    const endOverflow = iconStyle
      ? Math.max(0, -parseFloat(iconStyle.marginRight) || 0, -parseFloat(iconStyle.marginInlineEnd) || 0)
      : 0;

    return grid.scrollWidth > grid.clientWidth + endOverflow + OVERFLOW_TOLERANCE;
  };

  const applyNavFit = (header) => {
    if (!header.navContainer || !header.headerGrid || !header.burgerIcon) return;
    if (isMobile()) return;

    const overflows = navContentOverflows(header);
    const nav = header.navContainer;
    const grid = header.headerGrid;

    nav.toggleAttribute('hidden', overflows);
    grid.toggleAttribute('fit-nav', overflows);

    if (overflows) {
      grid.prepend(header.burgerIcon);

      if (typeof header.emit === 'function') header.emit('drawerActivated', {});

      return;
    }

    const icon = header.burgerIcon.firstElementChild;

    if (icon) icon.classList.remove('is-opened');

    header.burgerIcon.remove();

    if (typeof header.emit === 'function') header.emit('drawerUnActivated', {});
  };

  const patchHeader = (header) => {
    if (!header || header.dataset.elazNavFit === 'true') return;
    if (typeof header.checkIsNavContainerFitAllLinks !== 'function') return;

    header.dataset.elazNavFit = 'true';

    header.checkIsNavContainerFitAllLinks = function checkIsNavContainerFitAllLinks() {
      if (!this.navContainer) return;
      if (this.__elazNavFitFrame) cancelAnimationFrame(this.__elazNavFitFrame);

      this.__elazNavFitFrame = requestAnimationFrame(() => {
        this.__elazNavFitFrame = 0;
        applyNavFit(this);
      });
    };

    header.checkIsNavContainerFitAllLinks();
  };

  const patchAll = () => {
    document.querySelectorAll(HEADER).forEach(patchHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchAll, { once: true });
  } else {
    patchAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    patchHeader(event.target.querySelector(HEADER));
  });
})();
